import Vue from 'vue'
import VueRouter from 'vue-router'

function lazyLoad (view) {
  return () => import('../views/' + view + '.vue')
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: lazyLoad('Home')
  },
  {
    path: '/select-date',
    name: 'selectDate',
    component: lazyLoad('SelectDate')
  },
  {
    path: '/select-song',
    name: 'selectSong',
    component: lazyLoad('SelectSongs')
  },
  {
    path: '/service',
    name: 'service',
    component: lazyLoad('Service')
  },
  {
    path: '/shared-service/:serviceId',
    name: 'sharedService',
    component: lazyLoad('SharedService')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
